module.exports = "<div class=breadcrumbs-wrapper> <a ui-sref=app.home> Menu </a> <span ng-repeat=\"crumb in $ctrl.crumbs\"> <i class=\"fa fa-chevron-right\"></i> <a ui-sref={{crumb.state}}({{crumb.params}})> {{ crumb.displayName }} </a> </span> <i class=\"fa fa-chevron-right\"></i> <a ng-click=$ctrl.reloadCurrentState()> {{ $ctrl.currentPageName }} </a> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/common/breadcrumbs/breadcrumbs.html
// module id = 335
// module chunks = 0